import { Title } from "@solidjs/meta";
import { ButtonA } from "~/common/button";
import { rootPath } from "~/routes";
import { AuthPageLayout } from "./_layout";

type Props = {
  strings: {
    title: string;
    body: string;
    goToHomepage: string;
  };
};

export default function InvitationNotFound(props: Props) {
  return (
    <AuthPageLayout>
      <Title>{props.strings.title}</Title>

      <div>
        <h1 class="text-2xl font-semibold">{props.strings.title}</h1>
        <p class="mt-2 text-typography-secondary">{props.strings.body}</p>
      </div>

      <ButtonA href={rootPath()} variant="primary" size="lg" width="full">
        {props.strings.goToHomepage}
      </ButtonA>
    </AuthPageLayout>
  );
}
